import Api from "@/utils/api";
import Vue from "vue";

const state = {
  learner_programs: [],
  learner_program: {},
  learner_courses: [],
  learner_course: {},
  learner_modules: [],
  learner_module: {},
  learner_lesson: {},
  tenant_lessons: [],
  learner_module_lessons: [],
  tenant: null,
  cart: {},
  cartTotal: {
    appliedCoupon: false,
    appliedCoupons: [],
    total: 0,
    afterPrice: 0,
  },
  wishlist: [],
  courses: {},
  per_course: {},
  tenant_assets: [],
  learner_new_course: {},
  external_courses: {},
  external_course: {},
  growthplan_courses: [],
};
const getters = {
  getCartTotal(state) {
    return state.cartTotal;
  },
  getLearnerWish(state) {
    return state.wishlist;
  },
  getLearnerCart(state) {
    return state.cart;
  },
  getLearnerPrograms(state) {
    return state.learner_programs;
  },
  getLearnerProgram(state) {
    return state.learner_program;
  },
  getLearnerCourses(state) {
    return state.learner_courses;
  },
  getExternalCourses(state) {
    return state.external_courses;
  },
  getLearnerCourse(state) {
    return state.learner_course;
  },
  getLearnerModules(state) {
    return state.learner_modules;
  },
  getLearnerModule(state) {
    return state.learner_module;
  },
  getLearnerModuleLessons(state) {
    return state.learner_module_lessons;
  },
  getLearnerLesson(state) {
    return state.learner_lesson;
  },
  getLearnerNewCourse(state) {
    return state.learner_new_course;
  },
  getExternalCourse(state) {
    return state.external_course;
  },
  getSubscribedCourses(state) {
    return state.courses;
  },
  getSubscribedCoursesPerCourse(state) {
    return state.per_course;
  },
  getCoursesGrowthPlans(state){
    return state.growthplan_courses
  }

};
const mutations = {
  updateCartTotal(state, data) {
    Vue.set(state.cartTotal, "appliedCoupon", true);
    Vue.set(state.cartTotal, "afterPrice", data.new_amount);
    state.cartTotal.appliedCoupons.push(data.coupon);
  },
  cartPrice(state, data) {
    Vue.set(state.cartTotal, "total", data);
  },
  addToWishList(state, data) {
    Vue.set((state.wishlist = data));
  },
  removeWishlistItem(state, id) {
    Vue.delete(state.wishlist, id);
  },
  addSubscribedCourse(state, data) {
    Vue.set(state.courses, data.id, data);
  },
  addPerCourseSubscribedCourse(state, data) {
    return (state.per_course = data);
  },
  addCartItem(state, data) {
    Vue.set(state.cart, data.id, data);
  },
  removeCartItem(state, id) {
    Vue.delete(state.cart, id);
  },
  setLearnerPrograms(state, data) {
    return (state.learner_programs = data);
  },
  setLearnerProgram(state, data) {
    return (state.learner_program = data);
  },
  setLearnerCourses(state, data) {
    return (state.learner_courses = data);
  },
  setExternalCourses(state, data) {
    return (state.external_courses = data);
  },
  setLearnerCourse(state, data) {
    return (state.learner_course = data);
  },
  setLearnerModules(state, data) {
    return (state.learner_modules = data);
  },
  setLearnerModule(state, data) {
    return (state.learner_module = data);
  },
  setLearnerModuleLessons(state, data) {
    return (state.learner_module_lessons = data);
  },
  setLearnerLesson(state, data) {
    return (state.learner_lesson = data);
  },
  setLearnerNewCourse(state, data) {
    return (state.learner_new_course = data);
  },
  setExternalCourse(state, data) {
    return (state.external_course = data);
  },
  setCourseGrowthPlans(state,data){
    return (state.growthplan_courses = data)
  }
};
const actions = {

  async getUserIP({ commit }, payload) {

    let learner_ip = localStorage.getItem("edclearn_learner_ip");

    if (learner_ip !== null) {
      return learner_ip;
    } else {
      return fetch('https://api.ipify.org?format=json')
      .then(x => x.json())
      .then(({ ip }) => {
        localStorage.setItem('edclearn_learner_ip', ip);
        return ip;
      }, error => {
        console.log("Error fetching IP: ")
        console.log(error)
        return '1.1.1.1';
      });
    }

  },

  async couponToCart({ commit }, payload) {
    let res = await Api.post(`/tenant/learner/apply-coupon`, payload, true);
    if (res.status == 200) {
      commit("updateCartTotal", {
        coupon: payload.coupon_code,
        new_amount: res.data.data.total_amount,
      });
      return true;
    } else {
      return res;
    }
  },

  async fetchNotification({ commit }) {
    let res = await Api.get(`/user/notifications`, true);
    return res.data.data.notifications;
  },
  async fetchEnrolledCourse({ commit }, payload) {
    let res = await Api.get(`/tenant/course/${payload.id}/show`, true);
    commit("addSubscribedCourse", res.data.data.course);
    return res;
  },
  async learnerSubscribedCourses({ commit }, payload) {

    let res = await Api.get(`/tenant/course/learner/mycourses`, true);
    let courses = res.data.data.mycourses.map((course) => {
      commit("addSubscribedCourse", course.course);
    });
    //console.log(res);
    return res;
  },

  async learnerSubscribedPerCourse({ commit }, payload) {

    let res = await Api.get(`/tenant/course/learner/mycourses?per_course_view=true`, true);
    let courses = res.data.data.mycourses.forEach((course) => {
      commit("addPerCourseSubscribedCourse", [course.course]);
    });
    return res;
  },
  async learnerCheckout({ commit }, payload) {
    let res = await Api.post(
      `/tenant/course/learner/checkout-course`,
      payload,
      true
    );
    return res;
  },
  async learnerRemoveFromCart({ commit, dispatch }, payload) {
    let res = await Api.delete(
      `tenant/learner/remove-cart`,
      {
        courses: [payload.id],
      },
      true
    );

    commit("removeCartItem", payload.id);
    dispatch("fetchCart");
  },
  async fetchCart({ commit }) {
    let res = await Api.get(`tenant/learner/fetch-cart`, true);

    commit("cartPrice", res.data.data.courses[1]);

    res.data.data.courses[0].data.map((item) => {
      commit("addCartItem", item);
    });
  },
  async learnerAddToCart({ commit ,dispatch }, payload) {
    //console.log(typeof payload.id);
    let data;
    if (typeof payload.id === "object") {
      data = [...payload.id];
    } else {
      data = [payload.id];
    }
    let res = await Api.post(
      `tenant/learner/add-cart`,

      {
        courses: data,
      },
      true
    );

    dispatch("fetchCart");

    // if (res.status == 201) {
    //   commit("addCartItem", payload);
    // }
  },
  async learnerAddToWishlist({ commit,dispatch }, payload) {
    //console.log(typeof payload.id);
    let data;
    if (typeof payload.id === "object") {
      data = [...payload.id];
    } else {
      data = [payload.id];
    }
    let res = await Api.post(
      `tenant/learner/add-wishlist`,

      {
        courses: data,
      },
      true
    );
    dispatch("fetchWishlist");

    // if (res.status == 201) {
    //   commit("addToWishList", payload);
    // }
  },
  async learnerRemoveFromWishlist({ commit, dispatch }, payload) {
    let res = await Api.delete(
      `tenant/learner/remove-wishlist`,
      {
        courses: [payload.id],
      },
      true
    );

    commit("removeWishlistItem", payload.wishlist_id);
    dispatch("fetchWishlist");
  },
  async fetchWishlist({ commit }) {
    let res = await Api.get(`tenant/learner/fetch-wishlist`, true);
    //
    // res.data.data.wishlist.map((item) => {
    //   commit("addToWishList", item);
    // });
    commit("addToWishList", res.data.data.wishlist);
  },

  async learnerFetchNote({}, payload) {
    let res = await Api.get(
      `tenant/learner/journal/fetch-all-journal?course=${payload.id}`,
      true
    );
    return res;
  },
  async createNote({}, payload) {
    let res = await Api.post(
      `tenant/learner/journal/${payload.id}/update-note`,
      payload,
      true
    );
    return res;
  },
  async fetchLearnerPrograms({ commit }) {
    let res = await Api.get("/tenant/program", true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerPrograms", res.data.data.programs);
      return true;
    } else {
      return res;
    }
  },

  async fetchSingleTenantProgram({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/program/single/${id}`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setTenantProgram", res.data.data.program);
      return true;
    } else {
      return res;
    }
  },

  async fetchLearnerCourses({ commit }) {
    let res = await Api.get("/tenant/course/list", true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerCourses", res.data.data.data.courses);
      return true;
    } else {
      return res;
    }
  },


  async fetchLearnerCourseProgress({},payload) {
     const { course_id } = payload
      let res = await Api.get(`/get-learner-progress/${course_id}`,true);
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      return res;
    }
  },

  async fetchExternalCourses({ commit }, payload) {
    let res = await Api.get(`fetch-external-course?tenant_prefix=${payload}`);
    if (res.status === 200 || res.stat === 201) {
      commit("setExternalCourses", res.data.data.data.courses.data);
      return true;
    } else {
      return res;
    }
  },
  async fetchSingleLearnerCourse({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/course/${id}/show`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerCourse", res.data.data.course);
      commit("setLearnerNewCourse", res.data.data.course);
      return true;
    } else {
      return res;
    }
  },

  async fetchLearnerNewCourse({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/course/${id}/show`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerNewCourse", res.data.data.course);
      return res;
    } else {
      return res;
    }
  },

  async fetchExternalSingleCourse({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/external/${id}`);
    if (res.status === 200 || res.status === 201) {
      commit("setExternalCourse", res.data.data.course);
      return res;
    } else {
      return res;
    }
  },

  async fetchLearnerModules({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/module/${id}/list`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerModules", res.data.data.data.modules);
      return true;
    } else {
      return res;
    }
  },
  async fetchSingleLearnerModule({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/module/${id}/show`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerModule", res.data.data.module);
      return true;
    } else {
      return res;
    }
  },

  async fetchLearnerModuleCourses({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/lesson/list?module=${id}`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerModuleLessons", res.data.data.data.lessons.data);
      return true;
    } else {
      return res;
    }
  },

  async fetchLearnerLesson({ commit }, payload) {
    let { id } = payload;
    if (typeof id === 'undefined') {
      return false;
    }
    let res = await Api.get(`tenant/lesson/${id}/show`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setLearnerLesson", res.data.data.lesson);
      return true;
    } else {
      return res;
    }
  },

  async learnerSubmitQuiz({ commit }, payload) {
    let { id, data } = payload;
    let res = await Api.post(`tenant/lesson/${id}/quiz/submit`, data, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async learnerSubmitExercise({ commit }, payload) {
    let { id, answers } = payload;
    let res = await Api.post(
      `tenant/exercise/learner/${id}/submit`,
      { answers },
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async learnerSubmitSurvey({ commit }, payload) {
    //should be id, survey, answers
    //console.log(payload);
    let { answers, id, survey_id } = payload;
    //console.log(id);
    //console.log(survey_id);
    //console.log(answers);
    let res = await Api.post(
      `tenant/survey/submit/${survey_id}`,
      { resource_id: id, answers },
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async takeGrowthPlan({ commit }, payload) {
    let { id, response } = payload;
    let res = await Api.post(
      `tenant/growth_plan/lesson/${id}/submit`,
      { response },
      true
    );
    //console.log({ res });
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async completeLesson({ commit }, payload) {
    //localStorage.setItem("use-backup-api", "true");
    let { id,ip } = payload;
    let res = await Api.put(
      `tenant/lesson/learner/${id}/complete-lesson`,
      { ip },
      true
    );
    if (res.status === 200 || res.status === 201) {
      //localStorage.setItem("use-backup-api", "false");
      return {status:true,data:res};
    } else {
      //localStorage.setItem("use-backup-api", "false");
      return res;
    }
  },

  async rateCourse({ commit }, payload) {
    let { id, rating_value } = payload;
    let res = await Api.post(
      `tenant/learner/rating/${id}`,
      { rating_value },
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async submitTestimonial({ commit }, payload) {
    let { id, testimonial } = payload;
    let res = await Api.post(
      `tenant/learner/testimonial/${id}/create`,
      { testimonial },
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async fetchCourseTestimonial({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/tenant/learner/testimonial?search=${id}`, true);
    if (res.status === 200 || res.status === 201) {
      return res.data.data.testimonials;
    } else {
      return res;
    }
  },

  async fetchCourseOpenTestimonials({ commit }, payload) {
    let res = await Api.get(
      `/tenant/testimonials/all/?search=${payload.id}&prefix=${payload.prefix}`,
      true
    );
    if (res.status === 200 || res.status === 201) {
      return res.data.data.testimonials;
    } else {
      return res;
    }
  },

  async fetchDiscussionBoards({ commit }, payload) {
    let res = await Api.get(`/tenant/discussion`, true);
    if (res.status === 200 || res.status === 201) {
      //console.log({ res });
      return res.data.data.discussion_boards;
    } else {
      return res;
    }
  },
  async fetchTenantDiscussionBoards({ commit }, payload) {
    let res = await Api.get(`/tenant/discussion/all`, true);
    if (res.status === 200 || res.status === 201) {
      //console.log({ res });
      return res.data.data.discussion_boards;
    } else {
      return res;
    }
  },
  async fetchDiscussionBoardMessages({ commit }, payload) {
    let res = await Api.get(`/tenant/discussion/${payload.id}/messages`, true);
    if (res.status === 200 || res.status === 201) {
      //console.log({ res });
      return res.data.data.discussions;
    } else {
      return res;
    }
  },

  async fetchDiscussionBoard({ commit }, payload) {
    let res = await Api.get(`/tenant/discussion/${payload.id}/single`, true);
    if (res.status === 200 || res.status === 201) {
      //console.log({ res });
      return res.data.data.discussion_board;
    } else {
      return res;
    }
  },

  async LearnerFetchLeaderboards({}) {
    let res = await Api.get(`tenant/learner/leaderboards`, true);
    return res;
  },

  async LearnerFetchLeaderboard({}, payload) {
    let res = await Api.get(`tenant/learner/leaderboards/${payload.id}`, true);
    return res;
  },

  async LearnerFetchJournals({}, payload) {
    let res = await Api.get(`tenant/learner/journal/fetch-all-journal`, true);
    //console.log({ ressss: res });
    return res;
  },

  async LearnerFetchJournal({}, payload) {
    let res = await Api.get(
      `tenant/learner/journal/single/${payload.id}`,
      true
    );
    //console.log({ ressss: res });
    return res;
  },
  async learnerFetchGrowthPlanCourses({commit},payload){
    let res = await Api.get(`tenant/growth_plan/learner/course-list/show`,true)
    if (res.status === 200 || res.status === 201) {
      commit("setCourseGrowthPlans", res.data.data.courses);
      return res;
    } else {
      return res;
    }
  },

  async LearnerFetchCoursePlans({commit},payload){
    let res = await Api.get(`tenant/growth_plan/course/${payload.id}/fetch`,true)
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return res;
    }
  },
  async LearnerFetchCourseGrowthPlans({commit},payload){
    let res = await Api.get(`tenant/growth_plan/learner/course-list/show`,true)
    if (res.status === 200 || res.status === 201) {
      return res.data.data;
    } else {
      return res;
    }
  },

  async LearnerShowGrowthPlanResponse({commit},payload){
    let res = await Api.get(`tenant/growth_plan/learner/user-response/${payload.course_id}/${payload.id}/fetch`,true)
    if (res.status === 200 || res.status === 201) {
      return res.data.data;
    } else {
      return res;
    }
  },


  async submitLearnerCourseGrowthPlan({commit}, payload){
    let res = await Api.post(`tenant/growth_plan/course/${payload.course_id}/submit`,payload,true)
   if (res.status === 200 || res.status === 201) {
      return res.data.data;
    } else {
      return res;
    }
  },

  async verifyCompletedCourses({commit}, payload){
    let res = await Api.get(`tenant/growth_plan/verify-completed-courses`,true)
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      return res;
    }
  },


  async learnerCourseRepay({commit}, payload){
    let res = await Api.post(`tenant/course/learner/${payload.course.id}/repay-course`,payload,true)
   if (res.status === 200 || res.status === 201) {
      return res.data.data;
    } else {
      return res;
    }
  },


  async learnerProgramPay({commit}, payload){
    let res = await Api.post(`tenant/course/learner/${payload.course.program_id}/repay-program`,payload,true)
    if (res.status === 200 || res.status === 201) {
      return res.data.data;
    } else {
      return res;
    }
  },


  async learnerPurchaseProgram({commit},payload){
    let res = await Api.post(`tenant/learner/program/${payload.programId}/purchase-program`,payload,true)
    if (res.status === 200 || res.status === 201) {
      return res.data.data;
    } else {
      return res;
    }
  },

  async sendSupportEmail({commit},payload){
    let res = await Api.post(`support/send`,payload)
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return false;
    }
  },
  async submitFinalGrowthPlan({commit},payload){
    let res = await Api.post(`tenant/growth_plan/final/submit`,payload,true)
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return res;
    }
  },
  async getWeeklyTnyPerformanceMessage({commit},payload) {
    let res = await Api.get(`single/${payload.learner_id}/performance`, true)
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return res;
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
